import { giphyCharcoal } from '@giphy/colors'
import { useContext } from 'react'
import { ArtboardFilter, artboardFilters } from '../../../../artboard-gl/types'
import { UGEContext } from '../../../context'
import Preview from './preview'
import { Control, ControlLabel, ControlSlider, ControlValue, Grid } from './style'

type Props = {
    className?: string
}

const UGEFiltersEditorGrid = ({ className }: Props) => {
    const { filter, filterIntensity = 1, setFilter, setFilterIntensity, trackGAEvent } = useContext(UGEContext)

    function onClick(filter?: ArtboardFilter) {
        setFilter(filter)

        if (filter) {
            trackGAEvent('creation_filter_add', {
                creation: {
                    filterEditorTool: filter,
                },
            })
        }
    }

    return (
        <Grid className={className}>
            <Preview active={!filter} onClick={onClick} />
            {artboardFilters.map((af) => (
                <Preview active={af === filter} filter={af} key={`uge-filter-editor-preview-${af}`} onClick={onClick} />
            ))}
            {filter && (
                <Control>
                    <ControlLabel>Intensity</ControlLabel>
                    <ControlSlider
                        color={giphyCharcoal}
                        defaultValue={1}
                        fillColor="#fff"
                        onSliderValueChange={setFilterIntensity}
                    />
                    <ControlValue>{Math.round(filterIntensity * 100)}%</ControlValue>
                </Control>
            )}
        </Grid>
    )
}

export default UGEFiltersEditorGrid
